import { ArrowLeft } from "lucide-react";
import { PRIVACY_SECTIONS } from "@/data/avisoPrivacidad";

function Paragraph({ content }) {
  const parts = Array.isArray(content) ? content : [content];
  return (
    <p>
      {parts.map((part) => typeof part === "string" ? part : (
        <a key={part.href} href={part.href} target={part.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer"
          className="font-semibold underline" style={{ color: "var(--mint-dark)" }} data-testid={part.testId}>{part.label}</a>
      ))}
    </p>
  );
}

function Block({ section }) {
  const { title, paragraphs = [], list, after = [] } = section;
  return (
    <section className="mt-10">
      <h2 className="font-display text-2xl font-bold tracking-tight" style={{ color: "var(--text-dark)" }}>{title}</h2>
      <div className="mt-3 space-y-3 text-base leading-relaxed" style={{ color: "var(--text-muted)" }}>
        {paragraphs.map((p, i) => <Paragraph key={i} content={p} />)}
        {list && (
          <ul className="list-disc pl-6 space-y-2">
            {list.map((li) => <li key={li.slice(0, 40)}>{li}</li>)}
          </ul>
        )}
        {after.map((p, i) => <Paragraph key={i} content={p} />)}
      </div>
    </section>
  );
}

export default function AvisoPrivacidad() {
  return (
    <main className="min-h-screen px-6 py-16" style={{ background: "var(--bg)" }} data-testid="privacy-page">
      <div className="mx-auto max-w-3xl">
        <a href="/" className="inline-flex items-center gap-2 text-sm font-semibold" style={{ color: "var(--mint-dark)" }} data-testid="privacy-back-link">
          <ArrowLeft size={16} /> Volver a la página principal
        </a>
        <h1 className="mt-8 font-display font-extrabold tracking-tighter text-4xl sm:text-5xl" style={{ color: "var(--text-dark)" }}>
          Aviso de Privacidad
        </h1>
        {PRIVACY_SECTIONS.map((s) => <Block key={s.title} section={s} />)}
      </div>
    </main>
  );
}
